import { createContext } from 'react'

const initialState = {
  modalRoot: null,
  popupRoot: null,
  tooltipRoot: null,
}

const PortalRootsContext = createContext<Record<keyof typeof initialState, HTMLElement | null>>(initialState)

export { initialState }
export default PortalRootsContext
